const lstMotivos = [
  {descricao: 'Ordem Técnica'},
  {descricao: 'Perfil do Risco'},
  {descricao: 'Sinistralidade Elevada'},
  {descricao: 'Condições Solicitadas x Baixo Volume Prêmio'}
];

export default lstMotivos;


// WEBPACK FOOTER //
// ./src/helpers/motivos-nao-aceita.js